import { permissionLabel } from "../../../lib/permissionLabels";
import type { Permission } from "../../../../shared/rbac/permissions";
import { Icon } from "../../Icon";
import { Text } from "../../Text";
import { DetailLabel, IconBadge } from "../shared";
import { PERMISSION_DESCRIPTIONS, PERMISSION_ICONS } from "./constants";
import { PermissionRowContent } from "./styled";

export function PermissionDetails({ permission }: { permission: Permission }) {
  return (
    <PermissionRowContent>
      <IconBadge
        style={{ background: "var(--alpha4)", color: "var(--text-primary)" }}
      >
        <Icon name={PERMISSION_ICONS[permission]} size={16} />
      </IconBadge>
      <DetailLabel>
        <Text variant="text-regular-md">{permissionLabel(permission)}</Text>
        {PERMISSION_DESCRIPTIONS[permission] && (
          <Text variant="text-small" color="var(--text-secondary)">
            {PERMISSION_DESCRIPTIONS[permission]}
          </Text>
        )}
      </DetailLabel>
    </PermissionRowContent>
  );
}
